import React from 'react';
import intl from 'react-intl-universal';

import styles from './index.module.scss';

const Index = () => {
  return (
    <div className={styles.remarkInfoBlock}>
      <p>{intl.get('drawer_extension_picker_remark_p1')}</p>
      <p>{intl.get('drawer_extension_picker_remark_p2')}</p>
      <p>{intl.get('drawer_extension_picker_remark_p3')}</p>
      <p>{intl.get('drawer_extension_picker_remark_p4')}</p>
      <p>{intl.get('drawer_extension_picker_remark_p5')}</p>
    </div>
  );
};

export default Index;
